import React from 'react'
import { ColumnDef, createColumnHelper } from '@tanstack/react-table'
import { Link } from 'react-router-dom'
import { dates } from 'src/helpers/displayhelpers'
import { ReportBuilderReports } from 'src/queries/cat/reporting/reportbuilder/useReportBuilderReports'

type TData = ReportBuilderReports[0]

const columnHelper = createColumnHelper<TData>()

const MODEL_LABELS: Record<string, string> = {
  position: 'Position',
  distribution: 'Distribution',
  candidate: 'Candidate'
}

export const columns: Array<ColumnDef<TData, any>> = [
  columnHelper.accessor('title', {
    header: 'Title',
    cell: (info) => {
      const id = info.row.original._id
      return <Link to={`/cat/views/reportbuilder/${String(id)}`}>{info.getValue()}</Link>
    }
  }),
  columnHelper.accessor('model', {
    header: 'Model',
    cell: (info) => MODEL_LABELS[info.getValue()] ?? info.getValue()
  }),
  columnHelper.accessor('_createdBy.name', {
    header: 'Created By'
  }),
  columnHelper.accessor('createdAt', {
    header: 'Created',
    cell: (info) => dates.dateOnly(info.getValue())
  }),
  columnHelper.accessor('_updatedBy.name', {
    header: 'Last Updated By'
  }),
  columnHelper.accessor('updatedAt', {
    header: 'Last Updated',
    cell: (info) => dates.dateOnly(info.getValue())
  })
]
